/* eslint-disable max-len */
import React from 'react';

import { formatDate } from '@search/helpers/src/formatDate';
import classname from '@search/classname/src';
import { Button, Typography } from '@vtblife/uikit';

import Image from '@search/vtbeco-frontend-core/view/common/components/Image';
import { useOfferCardVasBlock } from '@search/vtbeco-frontend-core/view/common/components/OfferCardVasBlock/useOfferCardVasBlock';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
import { ClOrderOfferVasOption } from './ClOrderOfferVasOption';

import Illustration from './illustration.url.svg';

import './ClOrderOfferCardVas.css';
const cn = classname.bind(null, 'ClOrderOfferCardVas');

type IProps = {
    isMobile?: boolean;
    regionId: number;
    offerId: string;
    userPhone: string;
}

const getOffsetForwardDay = (countDays: number) => {
    const nowDate = new Date();

    nowDate.setDate(nowDate.getDate() + countDays);

    return formatDate(Number(nowDate) / 1000);
};

export const ClOrderOfferCardVas: React.FC<IProps> = ({
    isMobile,
    regionId,
    offerId,
    userPhone
}) => {
    const staticPath = useStaticPathConfig();

    const {
        vasPriceOption,
        vasPriceOptions,
        handleBuyVas,
        setVasPeriodValue
    } = useOfferCardVasBlock({
        offerId,
        regionId,
        userPhone
    });

    const renderMainText = (
        <div className={cn('main-text', { isMobile })}>
            <Typography variant={isMobile ? 'h4' : 'h2'} bold>
                Продвинуть объявление
            </Typography>
            <Typography
                variant={isMobile ? 'secondary-alone' : 'primary'}
                className={cn('description', { isMobile })}
            >
                Ваше объявление станет выше любых бесплатных на&nbsp;страницах поиска. Сделать его более заметным помогают увеличенный размер карточки и&nbsp;большее количество фотографий.
            </Typography>
        </div>
    );

    if (! vasPriceOption) return null;

    return (
        <div className={cn(null, { isMobile })}>
            <div className={cn('flex-wrapper')}>
                <div className={cn('image-wrapper', { isMobile })}>
                    <Image
                        className={cn('image', { isMobile })}
                        width={281}
                        height={174}
                        url={`${staticPath}${Illustration}`}
                    />
                </div>
                {! isMobile ? renderMainText : null}
            </div>
            {isMobile ? renderMainText : null}
            <div className={cn('options', { isMobile })}>
                {vasPriceOptions.map(item => {
                    const dates = {
                        date: getOffsetForwardDay(item.days).fullDate,
                        dateMobile: getOffsetForwardDay(item.days).dateAndTime.date
                    };

                    return (
                        <ClOrderOfferVasOption
                            key={item.value}
                            isActive={vasPriceOption?.value === item.value}
                            onClick={() => setVasPeriodValue(item.value)}
                            title={item.label}
                            date={isMobile ? dates.dateMobile : dates.date}
                            actualPrice={item.actualPrice}
                            oldPrice={item.oldPrice}
                            discount={item.discount}
                            isMobile={isMobile}
                        />
                    );
                })}
            </div>
            <Button
                onClick={handleBuyVas}
                fullWidth
                variant='primary'
            >
                {isMobile ? 'Подключить продвижение' : `Подключить продвижение за\u00A0${vasPriceOption.actualPrice}\u00A0₽`}
            </Button>
        </div>
    );
};
